import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {onBeforeUnmount, onMounted, Ref, ref} from '@vue/composition-api';
import {useFindPlaces} from './find-places';
import {useInterestFilter} from './interest-filter';

export function useCommonFind(
  category: Ref<UserActivityCategoryEnum>,
  onShowDetails: (x: string) => void = () => null,
  loadAdditionalExperiences: () => void = () => null,
) {
  const {filterValue, onSearchFilter, ...restOfInterestFilters} = useInterestFilter(
    category,
    loadAdditionalExperiences,
  );
  const {searchPois, ...restPlasesSearch} = useFindPlaces(category, onShowDetails);

  const searchInputValue = ref('');
  const onSearchInputChange = async (v: string) => {
    searchInputValue.value = v;
    filterValue.value = v;
    searchPois(v);
    onSearchFilter(v);
  };

  const onSearchInputChangeEv = (e: Event) => {
    const value = (e.target as HTMLInputElement).value;
    onSearchInputChange(value);
  };

  const clearSearchOptions = (event: MouseEvent | PointerEvent) => {
    if (!(event as PointerEvent).pointerType) {
      return;
    }
    filterValue.value = '';
    searchInputValue.value = '';
    onSearchFilter('');
  };

  onMounted(() => {
    document.addEventListener('click', clearSearchOptions);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', clearSearchOptions);
  });

  return {
    searchInputValue,
    onSearchInputChange,
    onSearchInputChangeEv,
    ...restPlasesSearch,
    ...restOfInterestFilters,
  };
}
